import React from "react";
import { useParams } from "react-router-dom";
import FinancialStatement from "./FinancialStatement";
import { balanceSheetData } from "../api/financialsData"; // Import the API call

export default function BalanceSheet() {
	const { symbol } = useParams();

	return (
		<FinancialStatement
			fetchDataFunction={balanceSheetData}
			statement={"Assets"}
			symbol={symbol}
		></FinancialStatement>
	);
}
